import {
  Box,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";
import { EGIconButton } from "../../../../MainComponents/Button/IconButton/IconButton";
import { AvatarLetter } from "../../../../MainComponents/Avatar/AvatarLetter";
import Comments from "../../Information/Comments";
import { useTranslation } from "react-i18next";
import { parseDateToLgComun4 } from "../../../../../helpers/dateTransform";

export const StatusComment = ({
  reportDetail,
  currentReportStatus,
  mainComment,
  filteredComments,
  hdlEditCurrentText,
  openModalConfirm,
  hdlDeleteText,
  closeModalConfirm,
}) => {
  const [t] = useTranslation("report");
  const theme = useTheme();

  return (
    <Box
      mb={1}
      px={0.5}
      pb={1}
      sx={{
        opacity:
          reportDetail?.status?.current === currentReportStatus ? 1 : 0.85,
      }}
    >
      <Typography color="primary" variant="h5" mb={0.75}>
        {t("Care.comments")}:
      </Typography>
      <Box
        sx={{ overflowY: "auto", maxHeight: "25vh", px: 1 }}
        className="dyBorder1 rounded"
      >
        {mainComment.current === currentReportStatus &&
          mainComment.message.trim() !== "" && (
            <Box
              sx={{ py: 1, pl: 2, pr: 0.75 }}
              className={filteredComments.length > 0 ? "border-bottom" : ""}
            >
              <ListItem
                sx={{ my: 0, p: 0 }}
                secondaryAction={
                  <EGIconButton
                    iconName="outline_edit"
                    iconColor="secondary"
                    title={t("Care.edit")}
                    onClick={() => hdlEditCurrentText(mainComment, "comment")}
                  />
                }
              >
                {mainComment.name && (
                  <ListItemAvatar sx={{ scale: 1.4, mr: "-33px" }}>
                    <AvatarLetter contact={mainComment} />
                  </ListItemAvatar>
                )}
                <ListItemText
                  primary={mainComment.name || ""}
                  primaryTypographyProps={{ variant: "h6" }}
                  secondary={`${t("Care.updated_on")}: ${parseDateToLgComun4(
                    mainComment.assigned
                  )}`}
                />
              </ListItem>
              <Comments
                text={mainComment.message}
                padding={0}
                maxLength={300}
                sx={{ mx: 0.5 }}
                variant="body2"
                color="secondary"
                fontSize={14}
              />
            </Box>
          )}

        {/* Render the list of filtered comments */}
        {filteredComments.length > 0 &&
          filteredComments.map((comment, i) => (
            <Box
              key={i}
              sx={{ py: 1, pl: 2, pr: 0.75 }}
              className={i < filteredComments.length - 1 ? "border-bottom" : ""}
            >
              <ListItem
                sx={{ my: 0, p: 0 }}
                secondaryAction={
                  <EGIconButton
                    iconName="trash_can"
                    iconColor="error"
                    title={t("Care.delete")}
                    placement="top"
                    onClick={() =>
                      openModalConfirm({
                        variant: "error",
                        title: t("Care.warning"),
                        titleColor: theme.palette.pink.main,
                        description1: t(
                          "Care.deleting_this_observation_will_permanently_erase_all_content"
                        ),
                        question: t("Care.do_you_want_continue"),
                        leftButtonText: t("Care.confirm"),
                        leftButtonColor: "error",
                        leftButtonVariant: "outlined",
                        onClickLeft: () => hdlDeleteText(comment),

                        rightButtonText: t("Care.cancel"),
                        rightButtonColor: "secondary",
                        onClickRight: () => closeModalConfirm(),
                        ethiquin: "megaphone",
                      })
                    }
                  />
                }
              >
                {comment?.user?.name && (
                  <ListItemAvatar sx={{ scale: 1.4, mr: "-33px" }}>
                    <AvatarLetter contact={comment.user} />
                  </ListItemAvatar>
                )}
                <ListItemText
                  primary={comment?.user?.name || ""}
                  primaryTypographyProps={{ variant: "h6" }}
                  secondary={`${t("Care.updated_on")}: ${parseDateToLgComun4(
                    comment.assigned
                  )}`}
                />
              </ListItem>
              <Comments
                text={comment.message}
                padding={0}
                maxLength={300}
                sx={{ mx: 0.5 }}
                variant="body2"
                color="secondary"
                fontSize={14}
              />
            </Box>
          ))}
      </Box>
    </Box>
  );
};
